site.boxlink = {
	init: function() {
		$('.boxlink a:first-of-type').each(function() {
			$(this).clone().empty().addClass('moreLink').appendTo($(this).closest('.boxlink'));
		});
	}
};

site.inits.push('site.boxlink.init()');
